import { Popup, Icon, List } from "semantic-ui-react";
import { CheckIcon, WarningIcon } from "../index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVials } from "@fortawesome/free-solid-svg-icons";

const styles = {
	errorPopup: { background: "#fff6f6", borderColor: "#e0b4b4" },
};

const TubesTab = ({ t, disabled, tubeStatus, missingVolumeTubes, tubeErrors, isMobile }) => {
	return (
		<Popup
			position="bottom right"
			disabled={!tubeErrors || tubeStatus || disabled}
			style={styles.errorPopup}
			offset="7px, 0"
			trigger={
				<span>
					<FontAwesomeIcon icon={faVials} style={{ width: ".75em" }} />
					{t("subMenu.tubes")}
					{!disabled && (tubeStatus ? <CheckIcon /> : <WarningIcon />)}
				</span>
			}
		>
			<Popup.Header>{t("subMenu.tubesNotPreleved")}</Popup.Header>
			<Popup.Content>
				<List bulleted>
					{tubeErrors.map((error, index) => (
						<List.Item key={`tube-${index}`}>{error}</List.Item>
					))}
				</List>
				{missingVolumeTubes && <div style={{ marginTop: 5 }}>{t("subMenu.tubesWithInsuffisantVolume")}</div>}
			</Popup.Content>
		</Popup>
	);
};

export default TubesTab;
